import React from 'react';

import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';
import NavigationTabBar, { NavigationTabBarProps } from '@ts-core/core/components/NavigationTabBar';

import { Student } from '../../types';

interface StudentDetailsHeaderProps extends NavigationTabBarProps {
  student?: Student;
  loading?: boolean;
}

const StudentDetailsHeader = (props: StudentDetailsHeaderProps) => {
  const { student, loading = false, tabs, activeTab, onGoToTab } = props;

  return (
    <Box borderBottom={1}>
      <Box display="flex" flexDirection="column" alignItems="center" my={2}>
        <Typography variant="h6" mt={-1} fontSize={32} loading={loading} skeletonWidth={280} skeletonHeight={40}>
          {student?.name}
        </Typography>
        <Typography variant="body2" gutterBottom loading={loading} skeletonWidth={200}>
          {student?.email}
        </Typography>
      </Box>
      <NavigationTabBar tabs={tabs} activeTab={activeTab} onGoToTab={onGoToTab} />
    </Box>
  );
};

export default StudentDetailsHeader;
